
import React, { useEffect, useState } from 'react';
import style from './style.module.scss';
import {IProps, IHandlers} from './types';
import {TextField} from '@material-ui/core';
import FlagPhonePickerReact from "external-components/flag-phone-picker-react";
import classNames from 'classnames';
import {FlagPhonePickerStyle, IStringEvent} from "external-components/flag-phone-picker-react/types";
import PhoneNumberService from "external-services/phone-number-service/index";
import {phoneNumberTypes} from "external-services/phone-number-service/phoneNumber.types";
import { PHONE_ERROR_MESSAGE } from 'app/services/customerValidation/customerValidation.types';

const NS = 'CustomerDetailsBasicEditor';

export default function CustomerDetailsBasicEditor(props: IProps & IHandlers) {
  const {
    firstName, phone, country,
    handleFirstNameChange, handlePhoneChange
  }: IProps & IHandlers = props;

  const [wPhone, setWPhone] = useState<string>('');
  const [wCountry, setWCountry] = useState<string>('');
  const [isPhoneNumberType, setIsPhoneNumberType] = useState<boolean>(null);
  const [error, setError] = useState('');
  const [originalPhone, setOriginalPhone] = useState('');
  useEffect(() => {
    formatPhone(phone);
  }, [phone])

  useEffect(() => {
    formatPhone(phone);
  }, [country])
  useEffect(() => {
    setOriginalPhone(phone);
  }, []);

  useEffect(() => {
    const res = PhoneNumberService.formatNumber(wPhone, wCountry, true, phoneNumberTypes.INTERNATIONAL);
    if (!res && (!!originalPhone || !!wPhone)) {
      setError(PHONE_ERROR_MESSAGE);
    } else {
      setError('');
    }
  }, [wPhone]);

  const handleChange = (e: {target: IStringEvent}) => {
    const name = e.target.name;
    const value = e.target.value;

    let _country = wCountry;
    let _phone = wPhone;

    if(name === 'phone') {
      setWPhone(value);
      _phone = value;
    } else if(name === 'country') {
      setWCountry(value);
      _country = value;
    }

    let formattedNumber = PhoneNumberService.formatNumber(_phone, _country, false, phoneNumberTypes.INTERNATIONAL, true);
    if(!formattedNumber && _phone) formattedNumber = PhoneNumberService.getCountryByCountryCode(_country).dial_code + _phone;
    handlePhoneChange(formattedNumber);
  }

  const formatPhone = (phoneStr: string) => {
    checkIsPhoneNumberType();
    let _customerCountry: string;
    let _customerFormattedPhone: string = phoneStr;
    if(phoneStr) {
        const parseNumber: any = PhoneNumberService.parseNumber(phoneStr, true);
        if(parseNumber && typeof parseNumber !== 'string') {
          if(parseNumber.nationalNumber){
            _customerCountry = parseNumber.country;
            _customerFormattedPhone = parseNumber.nationalNumber;
          }
        }else{
          const countryOnly = PhoneNumberService.getCountryByDialCode(phoneStr);
          if(countryOnly) {
            _customerCountry = countryOnly.code;
            _customerFormattedPhone = '';
          }
        }
    }

    if(_customerCountry && wCountry && _customerCountry !== wCountry) {
      const _customerCountryData = PhoneNumberService.getCountryByCountryCode(_customerCountry);
      const wCountryData = PhoneNumberService.getCountryByCountryCode(wCountry);
      if(_customerCountryData && wCountryData && _customerCountryData.dial_code === wCountryData.dial_code) {
        _customerCountry = wCountry;
      }
    }

    const tempCountry = _customerCountry || wCountry || country || 'AU';
    wCountry!==tempCountry && setWCountry(tempCountry);
    _customerFormattedPhone !== wPhone && setWPhone(_customerFormattedPhone);
  }

  const checkIsPhoneNumberType = () => {
    if(isPhoneNumberType === null) {
      const checkPhone = phone;
      if(checkPhone) {
        const parseNumber = PhoneNumberService.parseNumber(checkPhone, true);
        if(parseNumber && typeof parseNumber !== 'string') {
          setIsPhoneNumberType(true);
        }else{
          setIsPhoneNumberType(false);
        }
      }else{
        setIsPhoneNumberType(true);
      }
    }
  }

  return (
    <div className={classNames({
      [style.root]: true,
      [style.rootColumn]: true,
    })}>
      <div className={style.textField}>
        <TextField label="Name" defaultValue={firstName}
         onChange={(evt) => {
            handleFirstNameChange(evt.target.value);
         }} />
      </div>
      {
        !isPhoneNumberType &&
        <div className={style.textField}>
          <TextField label="Phone" defaultValue={phone}
          onChange={(evt) => {
              handlePhoneChange(evt.target.value);
          }} />
        </div>
      }
      {
        isPhoneNumberType &&
        <div className={style.textField}>
          <FlagPhonePickerReact
            includeAutocomplete={false}
            uiStyle={FlagPhonePickerStyle.diary}
            searchCustomer={() => {
              return;
            }}
            customers={[]}
            value={wPhone}
            handleBlur={() =>  {}}
            handleChange={handleChange}
            country={wCountry}
            handleWholeFormChangeForAutocomplete={() => {}}
            forceValidation={true}
            touched={true}
            errors={error}
            maxLength={25}
            overrideStyles={{
              focusedColor: '#992662'
            }}
            name="phone"
          />
        </div>
      }
      <div className={style.height200}></div>
    </div>
  )
}

